import React, { useState } from "react";

const InputMasking = ({ placeholder = "Enter a number..." }) => {
  const [value, setValue] = useState("");

  // Handle input changes and format with commas
  const handleInputChange = (e) => {
    const input = e.target.value;

    // Remove non-numeric characters
    const numericValue = input.replace(/[^0-9]/g, "");

    // Format the numeric value with commas
    const formattedValue = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    setValue(formattedValue);
  };

  return (
    <div>
      <label className="form-label">Input Masking</label>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="number-input form-control input-lg"
      />
    </div>
  );
};

export default InputMasking;
